import { type FC, useEffect } from 'react';

import { useNavigate, useLocation } from 'react-router';

import { HelseregistreJSProject } from '../../../../types/project-name-constant';
import type { HNHelseregistreJS } from '../../../../types/Resources';

import Loader from '@helsenorge/designsystem-react/components/Loader';
import Modal from '@helsenorge/designsystem-react/components/Modal';

import type { BreadcrumbLink } from '@helsenorge/core-framework/breadcrumb';
import PageRoot from '@helsenorge/core-framework/pageroot';
import SafeHTML from '@helsenorge/framework-utils/components/safe-html';
import { getPath } from '@helsenorge/framework-utils/hn-page';

import MeldeFeilForm from './melde-feil-form';
import { useResources } from '../../../../resources';
import { useAppDispatch, useAppSelector } from '../../../store/hooks';
import { SUBMIT_MESSAGE_DISMISS } from '../register-melding';

const MeldeFeilContainer: FC = () => {
  const navigate = useNavigate();
  const locationHook = useLocation();

  const resources = useResources<HNHelseregistreJS>(HelseregistreJSProject);
  const dispatch = useAppDispatch();

  const {
    meldeFeilRegister: register,
    meldeFeilControlHash: controlHash,
    meldeFeilError,
    sentMeldeFeil,
    sendingMeldeFeil,
  } = useAppSelector(state => state.registermelding);

  useEffect(() => {
    if (!register || !controlHash) {
      navigate('/');
    }
  }, [navigate, register, controlHash]);

  if (!resources || !register || !controlHash) {
    return null;
  }

  const onReset = (): void => {
    dispatch(SUBMIT_MESSAGE_DISMISS());
    navigate('/');
  };

  const location = `/${getPath()}${locationHook.pathname}`;
  const breadcrumLink: BreadcrumbLink = { renderAsRouterLink: true, url: '/', name: resources.helseregistre_navigatebacklink_title };
  return (
    <PageRoot
      redirectTo={location}
      breadcrumbLink={breadcrumLink}
      pageTitle={`${resources.messageSubmitHeading} ${register.navn} `}
      hideHelpTrigger
      enableSurveys={false}
    >
      {resources.meldeFeilInfo}
      <p>{resources.messageSubmitDescription}</p>
      <MeldeFeilForm meldeFeilRegister={register} resources={resources} controlHash={controlHash} onReset={onReset} />
      {meldeFeilError && (
        <Modal variant="error" title={resources.default_ErrorMessage_Title} onSuccess={onReset} onClose={onReset}>
          {resources.default_ErrorMessage_Body}
        </Modal>
      )}
      {sentMeldeFeil && (
        <Modal title={resources.conversationSubmitConfirmationHeading} onSuccess={onReset} onClose={onReset}>
          <p> {resources.conversationSubmitConfirmationDescriptionTitle}</p>
          <SafeHTML html={resources.conversationSubmitConfirmationDescriptionBody} tagName="span" />
        </Modal>
      )}
      {sendingMeldeFeil && <Loader overlay="screen" color="black" />}
    </PageRoot>
  );
};

export default MeldeFeilContainer;
